<div class="activity-logs-wrapper">
    <sync-data-list
        *ngIf="columns.length"
        [data]="activityLogs"
        [columns]="columns"
        [showFilter]="true"
        [showSearch]="false"
        [searchConfig]="searchConfig"
        sortedColumnKey="servtime"
        [isSortAsc]="true"
        [isSelectable]="false"
        [showListFilterOption]="true"
        [filterControls]="filterControls"
        [onListFilterChange]="onListFilterChange"
        [isLoading]="isLoading"
        [isSelectable]="false"
        >
    </sync-data-list>
    <div class="load-more" *ngIf="hasMore">
        <sync-button
            type="outlined"
            [isLoading]="isLoadMoreLoading"
            label="Load more..."
            (click)="onLoadMore()"
        ></sync-button>
    </div>
</div>
<ng-template #eventItemRef let-data="data">
    <div class="event-item">
        <app-activity-log-item [eventItem]="data" [eventSharedata]="shareSyncIds"></app-activity-log-item>
    </div>
</ng-template>